import balanceStatus from './balanceStatus'
import billingTriggerType from './billingTriggerType'
import boolean from './boolean'
import cpfCnpj from './cpfCnpj'
import currency from './currency'
import collectionType from './collectionType'
import language from './language'
import monetizationType from './monetizationType'
import phone from './phone'
import planIntervalType from './planIntervalType'
import purchaseStatus from './purchaseStatus'
import subscriptionStatus from './subscriptionStatus'
import toDate from './toDate'
import uppercase from './uppercase'

export default {
  install: (Vue, options = {}) => {
    options.moment.locale('pt-br')

    Vue.filter('balanceStatus', balanceStatus)
    Vue.filter('billingTriggerType', billingTriggerType)
    Vue.filter('boolean', boolean)
    Vue.filter('collectionType', collectionType)
    Vue.filter('cpfCnpj', cpfCnpj)
    Vue.filter('currency', currency)
    Vue.filter('language', language)
    Vue.filter('planIntervalType', planIntervalType)
    Vue.filter('purchaseStatus', purchaseStatus)
    Vue.filter('subscriptionStatus', subscriptionStatus)
    Vue.filter('monetizationType', monetizationType)
    Vue.filter('phone', phone)
    Vue.filter('toDate', toDate(options.moment))
    Vue.filter('uppercase', uppercase)
  },
}
